// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__xDBbc","selected":"Tabs_selected__Vyv0v"};